<template>
    <div class="px-6">
        <div class="mb-4">
            <h3 class="text-smoke-dark text-sm ">Enter your card details to pay NGN 30,000</h3>
        </div>
        <div class="grid grid-cols-2 gap-6 mb-24">
            <div class="col-span-2">
                <input
                    type="text"
                    class="h-12 px-4 placeholder-grey-300 text-sm rounded-md border border-snow-200 w-full"
                    placeholder="Card Number"
                />
            </div>
            <div class="col-span-1">
                <input
                    type="text"
                    class="h-12 px-4 placeholder-grey-300 text-sm rounded-md border border-snow-200 w-full"
                    placeholder="MM / YY"
                />
            </div>
            <div class="col-span-1">
                <input
                    type="text"
                    class="h-12 px-4 placeholder-grey-300 text-sm rounded-md border border-snow-200 w-full"
                    placeholder="CVV"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped></style>
